module.exports = __webpack_public_path__ + "9e2b3ad0996b158dddc89f42f75fe558.svg";